// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"ac00fed6","26":"9a6ccf6a","32":"5dfa28d9","916":"0edce684"}[chunkId] + ".chunk.js";
};